module.exports = __webpack_public_path__ + "static/media/Ремболович А. Шевелев А., Федоров К..1c371312.pdf";